
import Vue from "vue";

export default Vue.extend({
  name: "AppModalButton",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      default: null,
    },
  },
  computed: {
    buttonVariantKey(): string {
      const { variant } = this;
      return variant && variant !== "flat" ? variant : "default";
    },
  },
});
